module.exports = __webpack_public_path__ + "static/media/flag-fa.2eb9a7f6.webp";